import Super from './-legacy';

export default class HomeLegacyRails extends Super {}
